import { render, staticRenderFns } from "./KnowledgeBaseArticlePage.vue?vue&type=template&id=6d02fee3&"
import script from "./KnowledgeBaseArticlePage.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports